import reducer from './reducers';
import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from '@/utils/middleware/promiseMiddleware';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middlewares = [applyMiddleware(promiseMiddleware)];

var initialize = (initialState = {}) => {
  const store = createStore(reducer, initialState, composeEnhancers(...middlewares));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextReducer = require('./reducers');
      store.replaceReducer(nextReducer);
    });
  }
  return store;
};

export default initialize();



// WEBPACK FOOTER //
// ./src/store.js